import type { IconName } from "@awesome.me/kit-01a9b9ee41/icons"
import { byPrefixAndName } from "@awesome.me/kit-01a9b9ee41/icons"
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"

type IconStyle = "solid" | "regular" | "brands" | "kit" | "kit-duotone"

const STYLE_TO_PREFIX = {
    solid: "fas",
    regular: "far",
    brands: "fab",
    kit: "fak",
    "kit-duotone": "fakd",
} as const

interface FaIconParams {
    name: IconName
    style: IconStyle
}

export function faIcon({ name, style }: FaIconParams): IconDefinition {
    const prefix = STYLE_TO_PREFIX[style]
    return byPrefixAndName[prefix][name]
}
